import BaseCommand from "@/models/api/commands/BaseCommand";

export class RecalculateTradeTermCommand extends BaseCommand {
  CommandName = "RecalculateTradeTerm";
  Command: string;
  constructor(sessionId: string, operationId: string, orderItemId: string) {
    super(sessionId, operationId);
    this.Command = orderItemId;
  }
}
